export default {
  state: {
    isLoading: false,
    loadingCount: 0
  },
  mutations: {
    INCREMENT_LOADING(state) {
      state.loadingCount++;
      state.isLoading = true;
    },
    DECREMENT_LOADING(state) {
      state.loadingCount--;
      state.isLoading = state.loadingCount > 0;
    }
  },
  actions: {
    startLoading({ commit }) {
      commit("INCREMENT_LOADING");
    },
    stopLoading({ commit }) {
      commit("DECREMENT_LOADING");
    }
  },
  getters: {
    isLoading: state => state.isLoading
  }
};